/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
var PropTypes = require("prop-types");
var Label_1 = require("./Label");
var ErrorMessage_1 = require("./ErrorMessage");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./SegmentedControlComplex.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-segmentedControlComplex");
exports.SegmentedControlComplex = function SegmentedControlComplex(props) {
    var children = props.children, label = props.label, onChange = props.onChange, value = props.value, errorMessage = props.errorMessage, link = props.link, onLinkClick = props.onLinkClick, className = props.className;
    return (React.createElement("div", { className: classnames(moduleClassName(), !!name && moduleClassName(name), className) },
        !!label && React.createElement(Label_1.Label, { label: label, link: link, onLinkClick: onLinkClick }),
        React.createElement("div", { className: moduleClassName("options") }, React.Children.map(children, function (child) {
            var childCasted = child;
            if (!childCasted) {
                return childCasted;
            }
            return React.cloneElement(childCasted, tslib_1.__assign({}, childCasted.props, { onClick: function (event) {
                    return onChange(childCasted.props.name, event);
                }, active: value === childCasted.props.name }));
        })),
        !!errorMessage && React.createElement(ErrorMessage_1.ErrorMessage, null, errorMessage)));
};
exports.SegmentedControlComplex.propTypes = {
    label: PropTypes.string,
    value: PropTypes.any,
    name: PropTypes.string,
    className: PropTypes.string,
    link: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    errorMessage: PropTypes.string,
    vertical: PropTypes.bool,
    onLinkClick: PropTypes.func,
    onChange: PropTypes.func.isRequired
};
exports.SegmentedControlComplexOption = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick, name = _a.name, active = _a.active;
    return (React.createElement("button", { role: "button", type: "button", name: name, onClick: onClick, "aria-pressed": active, className: classnames(moduleClassName("option"), active && moduleClassName("option-isActive"), className) }, children));
};
exports.SegmentedControlComplexOption.propTypes = {
    active: PropTypes.bool,
    name: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string
};